// import 'core-js/stable';
import './src/utils/urlPolyfill';
import '@expo/metro-runtime';
import 'regenerator-runtime/runtime';
import useLoadAssets from './src/hooks/useLoadAssets';
import { ResetAppProvider } from './src/components/ResetAppProvider';
import { useEnvironment } from './src/hooks/useEnvironment';
import PrimaryRecordApp from './src/PrimaryRecordApp';
import { handle1UpHealthRedirect } from './src/utils/handle1UpHealthRedirect';
import { handleFastenRedirect } from './src/utils/handleFastenRedirect';
import { captureFastenRedirectParams } from './src/components/screens/Tabs/Account/RedirectScreen';
import { hideConsoleErrors } from './src/utils/hideConsoleErrors';
import { Platform, View } from 'react-native';
import React from 'react';
import * as SplashScreen from 'expo-splash-screen';

// reduce console noise of known and uncontrollable issues
hideConsoleErrors();

if (Platform.OS !== 'web') {
    // Keep the splash screen visible while we fetch resources
    SplashScreen.preventAutoHideAsync();

    // Set the animation options. This is optional.
    SplashScreen.setOptions({
        duration: 500,
        fade: true,
    });
}

const blockAppLoadForOneUpHealthRedirect = handle1UpHealthRedirect().shouldBlockAppLoad;
const blockAppLoadForFastenRedirect = handleFastenRedirect().shouldBlockAppLoad;

// Capture Fasten redirect params (org_connection_id, error, etc.) from the URL immediately,
// before React Navigation processes the route and strips query params.
captureFastenRedirectParams();

function App() {
    const { isAssetLoadComplete } = useLoadAssets();
    const environment = useEnvironment();
    const appStillPending =
        !isAssetLoadComplete ||
        environment === 'loading' ||
        blockAppLoadForOneUpHealthRedirect ||
        blockAppLoadForFastenRedirect;

    if (appStillPending) return null;

    const onLayoutRootView = () => {
        if (Platform.OS !== 'web') {
            SplashScreen.hide();
        }
    };

    return (
        <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }} onLayout={onLayoutRootView}>
            <ResetAppProvider>
                <PrimaryRecordApp environment={environment} />
            </ResetAppProvider>
        </View>
    );
}

export default App;
